import React from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";

export function ConfirmOrCancelDialog({ title, content, size, isOpen, onCancelClickEvent, onConfirmClickEvent }) {
  return (
    <>
      <Dialog open={isOpen} handler={onCancelClickEvent} size={size || "sm"} className="bg-background border border-primary">
        <DialogHeader>
          <h4>{title}</h4>
        </DialogHeader>
        <DialogBody>
          <p>{content}</p>
        </DialogBody>
        <DialogFooter>
          <Button onClick={onCancelClickEvent} className="button-secondary mr-4">
            Cancel
          </Button>
          <Button onClick={onConfirmClickEvent} className='button-primary'>
            Confirm
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}